/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPaymentMethod = 'NONE' | 'CREDIT_CARD' | 'APPLE_PAY' | 'ANDROID_PAY' | 'PAYPAL' | 'SAMSUNG_PAY' | 'MOBILE_PAY';

export const EPaymentMethod = {
    None: 'NONE' as EPaymentMethod,
    CreditCard: 'CREDIT_CARD' as EPaymentMethod,
    ApplePay: 'APPLE_PAY' as EPaymentMethod,
    AndroidPay: 'ANDROID_PAY' as EPaymentMethod,
    Paypal: 'PAYPAL' as EPaymentMethod,
    SamsungPay: 'SAMSUNG_PAY' as EPaymentMethod,
    MobilePay: 'MOBILE_PAY' as EPaymentMethod
};

